import AuthService from "../services/Auth";

export const ADMIN_ROLE = 'ADMIN';
export const HR_ROLE = 'HR';
export const MANAGER_ROLE = 'MANAGER';
export const FINANCE_ROLE = 'FINANCE';
export const USER_ROLE = 'USER';

export const isAuth = ({next, router}) => {
  const token = localStorage.getItem('access_token');
  if (!token) {
    return router.push({name: 'page-login'});
  }

  return next();
};


export const hasOneOfRoles = ({next, router}, roles) => {
  const hasRole = AuthService.hasOneOfRoles(roles);
  if (hasRole) {
    return next();
  }
  return router.push({name: 'home'});
};
